<div class="container">
    <div class="form-wrapper">
        <h1> {{ 'translations.login' | translate }} </h1>

        <form (ngSubmit)="login()" [formGroup]="loginFormGroup" class="login-form">
            <mat-form-field class="form-full-width">
                <mat-label> {{ 'translations.username' | translate }} </mat-label>
                <input formControlName="username" matInput type="text">
            </mat-form-field>

            <mat-form-field class="form-full-width">
                <mat-label> {{ 'translations.password' | translate }} </mat-label>
                <input formControlName="password" matInput [type]="isPasswordVisible ? 'text' : 'password'">
                <button class="show-password-button" mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button">
                  <mat-icon>{{ isPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>
            
            <mat-checkbox formControlName="stayLoggedIn" class="example-margin">{{ 'translations.stay-logged-in' | translate }}</mat-checkbox>

            <!-- <ngx-recaptcha2 id="captcha" #captchaElem
                [siteKey]="siteKey"
                [useGlobalDomain]="false"
                formControlName="recaptcha">
            </ngx-recaptcha2> -->

            <button type="submit"> {{ 'translations.login' | translate }} </button>
        </form>
    </div>
</div>
